module.exports = __webpack_public_path__ + "static/media/tfol.63837dc5.jpg";